import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";

/**
 * /thank-you - Minimal branded confirmation route used as the Google Ads
 * conversion-tracking landing URL. Most users will only ever see this URL
 * briefly in the address bar after a successful form submission (the visible
 * UI on the actual submission remains the hero/modal confirmation state).
 *
 * However, if a user lands here directly (back button, shared link, bookmark)
 * this lightweight page is what they will see - so it must not 404.
 */
const ThankYou = () => {
  return (
    <main
      data-testid="thank-you-page"
      className="min-h-[calc(100vh-80px)] flex items-center justify-center bg-brand-charcoal text-brand-cream px-6 py-20"
    >
      <div className="max-w-xl w-full text-center flex flex-col items-center">
        <div className="mb-10">
          <Logo size="lg" />
        </div>

        <h1
          className="font-serif font-light text-brand-cream leading-tight mb-5"
          style={{ fontSize: "clamp(2.5rem, 6vw, 4rem)" }}
        >
          Thank You.
        </h1>

        <p className="font-sans text-base md:text-lg text-brand-cream/65 leading-relaxed max-w-md mb-10">
          Our team will WhatsApp you within 2 hours to confirm your sample visit.
        </p>

        <Link
          to="/collection"
          data-testid="thank-you-back-to-collection"
          className="inline-flex items-center gap-2 px-6 py-3 bg-brand-gold text-brand-charcoal font-sans text-sm font-medium uppercase tracking-[0.2em] transition-all hover:bg-brand-gold/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 focus-visible:ring-offset-brand-charcoal"
          style={{ borderRadius: "5px" }}
        >
          <span>Back to Collection</span>
          <span className="text-lg leading-none">→</span>
        </Link>
      </div>
    </main>
  );
};

export default ThankYou;
